module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_8-f34243b4c8e05a6b457185aba91c2b99.jpg";